<template>
  <div class="layout-index">
    <!-- <Header :active="'home'"></Header> -->
    <!-- <router-view/> -->
    <index-hbcj v-if="mode==='hbcj'" />
    <!-- <Footer /> -->
    <back-top></back-top>
  </div>
</template>

<script>
import Head from '../../components/header.vue'
import IndexHbcj from './index-hbcj.vue'

// import Header from './../../components/public/header'
// import Footer from './../../components/public/footer'
export default {
  components: {
    Head,
    IndexHbcj
    // Header,
    // Footer
  },
  data () {
    return {
      mode: 'hbcj'
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue